/*
 *
 * DownloadFloatingModal
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 19-Jun-2025
*/

import DownloadFloatingModal from './DownloadFloatingModal'

export default DownloadFloatingModal
